import React, { useState } from 'react'
import Emailer from '../Common/Emailer'

const InfoBanner = ({ msg, tripId }) => {
  const [toggleModal, setToggleModal] = useState(false)
  const [emailerSuccessModal, setEmailerSuccessModal] = useState(false)

  return (
    <React.Fragment>
      <If condition={toggleModal}>
        <Emailer
          toggleModal={toggleModal}
          emailerText="E-ticket"
          href={`/communication/selfcare/api/v2/sendEticket/${tripId}?toEmail=`}
          setToggleModal={setToggleModal}
          setEmailerSuccessModal={setEmailerSuccessModal}
          emailerSuccessModal={emailerSuccessModal}
          tripId={tripId}
        />
      </If>
      <If condition={msg && msg.length > 0}>{msg.map(item => (
        <div className="new-banner flex flex-between fs-11 px-4 py-2">
          <p className="flex-1">{item}</p>
          <a className="c-blue cursorPoi pl-4" onClick={() => setToggleModal(true)}>Resend</a>
        </div>
      ))}
      </If>
    </React.Fragment>
  )
}

export default InfoBanner
